/**
 * Identificadores do documento — cards, blocos, ligações, opções e
 * condições. A API aceita `^[A-Za-z0-9_-]{1,64}$` (`definition.py`, ID_RE);
 * o builder gera um prefixo legível e 8 caracteres aleatórios ("b-1f3a9c0d").
 */
export const ID_RE = /^[A-Za-z0-9_-]{1,64}$/;

export type IdPrefix = 'g' | 'b' | 'e' | 'i' | 'c';

function random8(): string {
  const uuid = globalThis.crypto?.randomUUID?.();
  if (uuid) return uuid.replace(/-/g, '').slice(0, 8);
  // Fora de contexto seguro (http em rede local) não há randomUUID.
  return Math.random().toString(36).slice(2, 10).padEnd(8, '0');
}

/** Um id novo, diferente de todos os já usados (`taken`). */
export function newId(prefix: IdPrefix, taken?: ReadonlySet<string>): string {
  for (;;) {
    const id = `${prefix}-${random8()}`;
    if (!taken?.has(id)) return id;
  }
}

/** Todos os ids do documento que precisam ser únicos (cards, blocos e ligações). */
export function takenIds(doc: {
  groups: { id: string; blocks: { id: string }[] }[];
  edges: { id: string }[];
}): Set<string> {
  const ids = new Set<string>();
  for (const g of doc.groups) {
    ids.add(g.id);
    for (const b of g.blocks) ids.add(b.id);
  }
  for (const e of doc.edges) ids.add(e.id);
  return ids;
}
